<template>
    <h1 class="search-results-title">
        <slot />
    </h1>
</template>

<style scoped lang="scss">
    .search-results-title {
        font-family: var(--joy-font-family-title);
        font-weight: var(--joy-font-weight-normal);
        font-size: var(--joy-font-size-primary-600);
        line-height: var(--joy-line-height-large);
        margin: 0;
    }
</style>
